/* Окно «Выгрузить выборку»: макета у окна нет — сетка как у окон журнала, итог плашкой. */

.body {
  display: flex;
  flex-direction: column;
  gap: var(--space-3);
  min-width: min(440px, 100%);
}

.text {
  margin: 0;
  color: var(--text-secondary);
}

.outcome {
  padding: 9px 12px;
  color: var(--text-brand);
  background: var(--bg-sunken);
  border-radius: 8px;
}

.problem {
  padding: 9px 12px;
  color: var(--danger);
  border: 1.5px solid var(--danger-hover);
  border-radius: 8px;
}

.buttons {
  display: flex;
  gap: 8px;
  justify-content: flex-end;
}
